import { attachSessionRefresh } from "@/lib/session";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});
attachSessionRefresh(api);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(formatApiErrorDetail).join("\n");
  const message = detail.message || detail.msg || detail.reason;
  if (typeof message === "string") {
    const parts = Array.isArray(detail.loc) ? detail.loc : detail.field ? [detail.field] : [];
    const field = parts.filter(x => !["body", "query", "payload"].includes(x))
      .map(x => typeof x === "number" ? `item ${x + 1}` : String(x).replace(/_id$/, "").replaceAll("_", " "))
      .join(" → ");
    return `${field ? field[0].toUpperCase() + field.slice(1) + ": " : ""}${message.replace(/^Value error, /, "")}`;
  }
  for (const key of ["errors", "issues", "detail"]) {
    if (detail[key]) return formatApiErrorDetail(detail[key]);
  }
  return "This request could not be completed. Check the fields and try again.";
}
